const apiSecurity = process.env.VUE_APP_URL_SECURITY_API;
const baseAPI = process.env.VUE_APP_URL_BASE_API;
export default class Endpoint {
  public solicitation = `${baseAPI}/api/paymentRequest`;
  public cancelSolicitation = `${baseAPI}/api/paymentRequest/cancel`;
  public denySolicitation = `${baseAPI}/api/paymentRequest/denied`;
  public approveSolicitation = `${baseAPI}/api/paymentRequest/approve`;
  public paySolicitation = `${baseAPI}/api/paymentRequest/pay`;
  public copySolicitation = `${baseAPI}/api/paymentRequest/copy`;
  public bankApproval = `${baseAPI}/api/PaymentRequest/Set-bank-approval`;
  public extendSolicitationExpiration = `${baseAPI}/api/PaymentRequest/extend-expiration`;

  public saveDraft = `${baseAPI}/api/paymentRequest/draft`;
  public costCenter = `${baseAPI}/api/CostCenter`;
  public costCenterByCompany = `${baseAPI}/api/CostCenter/by-companyid`;
  public creditor = `${baseAPI}/api/Creditor`;
  public creditorBySienge = `${baseAPI}/api/Creditor/by-siengeid`;
  public company = `${baseAPI}/api/Company`;
  public companyAll = `${baseAPI}/api/Company/all`;
  public companiesNew = `${baseAPI}/api/Company/fund-paying`;
  public companyApprover = `${baseAPI}/api/Company/approver`;
  public userSector = `${baseAPI}/api/User/my-department`;
  public financialPlain = `${baseAPI}/api/FinancialBudget`;
  public login = `${baseAPI}/api/solicitation`;
  public documentType = `${baseAPI}/api/Document/type`;
  public paymentMethod = `${baseAPI}/api/Document/payment-method`;
  public paymentType = `${baseAPI}/api/Document/payment-type`;
  public users = `${baseAPI}/api/User`;

  public uploadFile = `${baseAPI}/api/File`;
  public uploadVoucher = `${baseAPI}/api/File/pay`;
  public deleteFiles = `${baseAPI}/api/File`;
  public testeList = `${baseAPI}/api/Teste/list`;
  public downloadFiles = `${baseAPI}/api/file`;

  public emergencialDays = `${baseAPI}/api/SystemParameter/emergeDays`;

  public auth = {
    getMenus: `${baseAPI}/api/security/menu`,
  };

  public fundAdministrators = `${baseAPI}/api/FundAdministrators`;

  public setPendency = `${baseAPI}/api/PaymentRequest/pending`;
  public resolve = `${baseAPI}/api/PaymentRequest/resolve`;
  public downloadCSV = `${baseAPI}/api/PaymentRequest/download/csv`;

  public approverId = `${baseAPI}/api/PaymentRequest/approve`;
  public approverModes = `${baseAPI}/api/approval-modes`;

  public importCSV = `${baseAPI}/api/PaymentRequest/import`;

  public costCenterImport = `${baseAPI}/api/PaymentRequest`;

  public setExported = `${baseAPI}/api/PaymentRequest/Set-Exported`;

  public creditorCreateUpdate = `${baseAPI}/api/Creditor/fund-paying`;

  public getStatementPayment = `${baseAPI}/api/StatementPayment/paymentRequest`;

  public generateReceipt = `${baseAPI}/api/StatementPayment/generateReceipt`;
}
